import script from "./ManageOrganization.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageOrganization.vue?vue&type=script&setup=true&lang=js"

import "./ManageOrganization.vue?vue&type=style&index=0&id=27d2e72e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d2e72e"]])

export default __exports__